<app-alert></app-alert>
<app-tabs *ngIf="true">
  <app-tab #tab1 tabTitle="{{ 'profile.my-data' | translate }}">
    <ng-container *ngIf="tab1.selected">
      <form class="form-horizontal" (ngSubmit)="onSubmit()" [formGroup]="myForm">
        <div class="profile">
          <div class="profile__label">{{ 'profile.photo' | translate }}</div>
          <div class="profile__control">
            <div class="profile__control--avatar">
              <img [src]="profileImage" (load)="handleImageLoad()" />
              <app-agres-icons iconsClass="agres-image"></app-agres-icons>
            </div>
            <div class="profile__control--file">
              <input
                (change)="uploadProfileImage($event)"
                type="file"
                id="imageUpload"
                accept=".png, .jpg, .jpeg"
                alt="{{ 'profile.photo' | translate }}" />
              <button for="imageUpload">{{ 'profile.upload' | translate }}</button>
            </div>
          </div>
        </div>
        <div class="field__row">
          <div class="field">
            <div class="field__label">{{ 'profile.name' | translate }}</div>
            <div class="field__wrap">
              <input class="field__input" type="text" formControlName="name" id="name" required />
            </div>
          </div>
          <div class="field">
            <div class="field__label">{{ 'global.mail' | translate }}</div>
            <div class="field__wrap">
              <input class="field__input" type="email" id="email" formControlName="id" />
            </div>
          </div>
          <!-- TELEFONE INPUT -->
          <div class="field">
            <div class="field__label">{{ 'global.phone' | translate }}</div>
            <div class="field__wrap">
              <input
                class="field__input"
                type="text"
                formControlName="phoneNumber"
                (input)="formatPhoneNumber()"
                id="phoneNumber" />
            </div>
          </div>
        </div>
        <div class="field__row">
          <div class="field">
            <div class="field__label">{{ 'global.identification' | translate }}</div>
            <div class="field__wrap">
              <input
                class="field__input"
                type="text"
                formControlName="nationalIdNumber"
                id="nationalIdNumber"
                maxlength="18"
                [class.error]="!isCpfCnpjValid(myForm?.get('nationalIdNumber').value)" />
                <!-- [mask]="outsideBrazil ? '' : getIdentificationMask()" -->
              <span
                class="field__input--alert"
                *ngIf="!isCpfCnpjValid(myForm?.get('nationalIdNumber').value) && !outsideBrazil">
                {{ 'global.validate.error-document-data' | translate }}
              </span>
            </div>
          </div>
          <div class="field">
            <div class="field__label">{{ 'global.company-name' | translate }}</div>
            <div class="field__wrap">
              <input
                class="field__input"
                type="text"
                name="company"
                id="company"
                formControlName="company"
                [class.error]="!myForm.controls.company.valid" />
            </div>
          </div>
        </div>
        <div class="field__space"></div>
        <ng-container formGroupName="addressFormGroup">
          <div class="field__row">
            <div class="field">
              <div class="field__label">{{ 'global.postalCode' | translate }}</div>
              <div class="field__wrap">
                <input
                  class="field__input"
                  type="text"
                  name="postalCode"
                  id="postalCode"
                  formControlName="postalCode"
                  (blur)="outsideBrazil ? '' : checkCep($event)" />
              </div>
            </div>
            <div class="field">
              <div class="field__label">{{ 'global.city' | translate }}</div>
              <div class="field__wrap">
                <input class="field__input" maxlength="50" type="text" name="city" id="city" formControlName="city" />
              </div>
            </div>
            <div class="field">
              <div class="field__label">{{ 'global.state' | translate }}</div>
              <div class="field__wrap">
                <input
                  class="field__input"
                  type="text"
                  name="uf"
                  id="uf"
                  maxlength="25"
                  formControlName="stateOrProvince" />
              </div>
            </div>
          </div>
          <div class="field__row">
            <div class="field">
              <div class="field__label">{{ 'global.country' | translate }}</div>
              <div class="field__wrap">
                <div class="field__select">
                  <select formControlName="country">
                    <option *ngFor="let country of countries" [value]="country">
                      {{ 'global.country_codes.' + country | translate }}
                    </option>
                  </select>
                </div>
                <span
                  class="field__input--alert"
                  *ngIf="displayMessage.country && !outsideBrazil"
                  [innerHTML]="displayMessage.country">
                </span>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="hidden__mobile">
          <div class="field__btns">
            <app-button
              type="submit"
              color="primary"
              icon="agres-check"
              styleClass="field__btns--margin"
              [disabled]="disableButton || !myForm.valid"
              title="{{ 'global.save' | translate }}">
            </app-button>
            <app-button
              type="button"
              color="danger"
              icon="agres-close"
              styleClass="field__btns--margin"
              (btnClick)="clearFormUserData()"
              title="{{ 'global.clear' | translate }}">
            </app-button>
          </div>
          <small
            ><a class="link-delete" (click)="linkToDeleteAccountPage()">{{
              'global.delete_account' | translate
            }}</a></small
          >
        </div>
      </form>

      <app-menu-pwa>
        <div class="pwa__list--info">
          <button type="button" (click)="onSubmit()" [disabled]="disableButton || !myForm.valid">
            <i class="agres-check"></i>
            <p>{{ 'global.save' | translate }}</p>
          </button>
        </div>
        <div class="pwa__list--info">
          <button type="button" (click)="clearFormUserData()">
            <i class="agres-close"></i>
            <p>{{ 'global.clear' | translate }}</p>
          </button>
        </div>
        <div class="pwa__list--info">
          <button type="button" (click)="linkToDeleteAccountPage()">
            <i class="agres-delete"></i>
            <p>{{ 'global.delete_account' | translate }}</p>
          </button>
        </div>
      </app-menu-pwa>
    </ng-container>
  </app-tab>
  <app-tab #tab2 tabTitle="{{ 'global.password' | translate }}">
    <div *ngIf="tab2.selected">
      <form (ngSubmit)="onSubmitNewPassword()" [formGroup]="myFormPassword">
        <div class="field__row">
          <div class="field">
            <div class="field__label">{{ 'profile.title-new-password' | translate }}</div>
            <div class="field__wrap">
              <input
                class="field__input"
                type="password"
                formControlName="password"
                value=""
                [type]="isPasswordVisible ? 'text' : 'password'"
                minlength="4"
                maxlength="16"
                autocomplete="off" />
              <span class="field__view">
                <app-agres-icons
                  styleClass="field__view"
                  [ngClass]="isPasswordVisible ? 'agres-eye' : 'agres-eye-off'"
                  (click)="togglePassword()"></app-agres-icons>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="field__label">{{ 'profile.title-new-password-confirm' | translate }}</div>
            <div class="field__wrap">
              <input
                type="password"
                formControlName="confirmPassword"
                class="field__input"
                value=""
                [type]="isConfirmPasswordVisible ? 'text' : 'password'"
                minlength="4"
                maxlength="16"
                autocomplete="off" />
              <span class="field__view">
                <app-agres-icons
                  styleClass="field__view"
                  [ngClass]="isConfirmPasswordVisible ? 'agres-eye' : 'agres-eye-off'"
                  (click)="confirmTogglePassword()"></app-agres-icons>
              </span>
            </div>
          </div>
        </div>
        <div class="hidden__mobile">
          <div class="field__btns">
            <app-button type="submit" color="primary" icon="agres-check" title="{{ 'global.update' | translate }}">
            </app-button>
            <app-button
              type="button"
              color="danger"
              icon="agres-close"
              (click)="clearFormPassword()"
              title="{{ 'global.clear' | translate }}">
            </app-button>
          </div>
        </div>
      </form>
      <app-menu-pwa>
        <div class="pwa__list--info">
          <button type="button" (click)="onSubmitNewPassword()">
            <i class="agres-check"></i>
            <p>{{ 'global.update' | translate }}</p>
          </button>
        </div>
        <div class="pwa__list--info">
          <button type="button" (click)="clearFormPassword()">
            <i class="agres-close"></i>
            <p>{{ 'global.clear' | translate }}</p>
          </button>
        </div>

      </app-menu-pwa>
    </div>
  </app-tab>

  <app-tab #tab3 [tabTitle]="'consent.manage' | translate">
    <ng-container *ngIf="tab3.selected">
      <!-- Header da seção -->
      <div class="prefs-header">
        <h2 class="prefs-header__title">{{ 'consent.manage' | translate }}</h2>
        <p class="prefs-header__subtitle">{{ 'consent.manage-subtitle' | translate }}</p>
      </div>

      <!-- Linha 1: Privacidade + Segurança -->
      <div class="prefs-row prefs-row--2col">
        <!-- Privacidade e Cookies -->
        <div class="preferences-card preferences-card--light">
          <div class="preferences-card__header">
            <h3 class="preferences-card__title">{{ 'consent.title' | translate }}</h3>
            <i class="fa fa-shield preferences-card__icon-decorative"></i>
          </div>
          <p class="preferences-card__description">{{ 'consent.description' | translate }}</p>
          @if (consentService.hasAnalyticsConsent()) {
            <div class="preferences-card__actions">
              <app-button
                type="button"
                color="danger"
                icon="agres-close"
                (click)="consentService.revokeConsent()"
                title="{{ 'consent.revoke' | translate }}">
              </app-button>
            </div>
          } @else {
            <div class="preferences-card__actions">
              <app-button
                type="button"
                color="primary"
                icon="agres-check"
                (click)="consentService.acceptAll()"
                title="{{ 'consent.accept' | translate }}">
              </app-button>
            </div>
          }
        </div>

        <!-- Segurança dos Dados -->
        <div class="preferences-card preferences-card--light">
          <div class="preferences-card__header">
            <h3 class="preferences-card__title">{{ 'consent.security-title' | translate }}</h3>
            <i class="fa fa-lock preferences-card__icon-decorative"></i>
          </div>
          <p class="preferences-card__description">{{ 'consent.security-description' | translate }}</p>
          <div class="preferences-card__actions">
            <a routerLink="/politica-privacidade" class="prefs-btn-outline">
              {{ 'consent.terms-link' | translate }} ↗
            </a>
          </div>
        </div>
      </div>

      <!-- Linha 2b: Baixar Todos os Dados (.zip — dados pessoais + tarefas) -->
      <div class="preferences-card preferences-card--light preferences-card--horizontal">
        <div class="preferences-card__side">
          <i class="fa fa-file-archive-o preferences-card__icon-decorative" style="font-size: 1.5rem"></i>
          <div>
            <h3 class="preferences-card__title">{{ 'privacy.export-all-title' | translate }}</h3>
            <p class="preferences-card__description">{{ 'privacy.export-all-description' | translate }}</p>
          </div>
        </div>
        <div class="preferences-card__actions--row">
          <app-button
            type="button"
            color="primary"
            icon="agres-download"
            [disabled]="downloadingAllData"
            (click)="downloadAllMyData()"
            title="{{ (downloadingAllData ? 'privacy.export-all-loading' : 'privacy.export-all-button') | translate }}">
          </app-button>
        </div>
      </div>

      <!-- Linha 3: Histórico de Sessões (largura total) -->
      <div class="preferences-card preferences-card--light">
        <div class="session-history-panel__header">
          <h4 class="session-history-panel__title">
            <i class="fa fa-history"></i>&nbsp;{{ 'sessions.title' | translate }}
          </h4>
          <div
            class="session-history-panel__filter"
            role="group"
            [attr.aria-label]="'sessions.filter-label' | translate">
            @for (opt of sessionDaysOptions; track opt) {
              <button
                type="button"
                class="session-history-panel__filter-btn"
                [class.session-history-panel__filter-btn--active]="sessionDaysFilter === opt"
                (click)="onDaysFilterChange(opt); $event.stopPropagation()">
                {{ opt }}D
              </button>
            }
          </div>
        </div>

        @if (loadingSessions) {
          <div class="session-history-panel__empty">
            <i class="fa fa-spinner fa-spin"></i>
          </div>
        } @else if (sessions.length === 0) {
          <div class="session-history-panel__empty">
            {{ 'sessions.no-data' | translate }}
          </div>
        } @else {
          <table class="session-history-panel__table">
            <thead>
              <tr>
                <th class="session-history-panel__th">{{ 'sessions.col-device' | translate }}</th>
                <th class="session-history-panel__th">{{ 'sessions.col-location' | translate }}</th>
                <th class="session-history-panel__th">{{ 'sessions.col-time' | translate }}</th>
                <th class="session-history-panel__th">{{ 'sessions.col-status' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (session of sessions; track session.id) {
                <tr>
                  <td class="session-history-panel__td">
                    <i
                      class="session-history-panel__device-icon fa"
                      [class.fa-desktop]="session.clientSource === 'browser'"
                      [class.fa-mobile]="session.clientSource === 'mobile'"
                      [class.fa-microchip]="session.clientSource === 'esp32'"
                      [class.fa-question-circle]="session.clientSource === 'unknown'">
                    </i>
                    <span class="session-history-panel__device-label">{{ session.deviceLabel }}</span>
                  </td>
                  <td class="session-history-panel__td session-history-panel__td--location">
                    {{ session.ipAddress || ('sessions.location-unknown' | translate) }}
                  </td>
                  <td class="session-history-panel__td">{{ session.timeLabel }}</td>
                  <td class="session-history-panel__td">
                    <span
                      class="session-history-panel__badge"
                      [class.session-history-panel__badge--current]="session.isCurrent"
                      [class.session-history-panel__badge--inactive]="!session.isCurrent">
                      {{ (session.isCurrent ? 'sessions.status-current' : 'sessions.status-inactive') | translate }}
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }

        <!-- Rodapé -->
        <div class="prefs-sessions-footer">
          <p class="prefs-sessions-footer__warning">{{ 'sessions.suspicious-warning' | translate }}</p>
          <app-button
            type="button"
            color="danger"
            icon="agres-close"
            (click)="terminateAllSessions()"
            title="{{ 'sessions.terminate-all' | translate }}">
          </app-button>
        </div>
      </div>
    </ng-container>
  </app-tab>
</app-tabs>
